module.exports = __webpack_public_path__ + "static/img/cry.5be415bd.png";